module.exports = __webpack_public_path__ + "img/18a81ed.jpg";